import React from 'react';
import SunsetScreen from './components/SunsetScreen';

const App = () => <SunsetScreen />;

export default App;
